import angular from 'angular';
import ExtractionServ from '../../services/extraction'

import fbFactCtrl from './fb-fact.controller'

import fbTrix from '../fb-trix'
import fbEditable from '../fb-editable'
import fbDateField from '../fb-date-field'

import IssuesTreeFactory from '../../models/trees/issues'
import fbIssueSelect from '../../components/fb-issue-select'

import TagsTreeFactory from '../../models/trees/tags'
import fbTagSelect from '../../components/fb-tag-select'

import SourcesTreeFactory from '../../models/trees/sources'
import fbSourceSelect from '../../components/fb-source-select'

let fbFact = {
  template: require('./fb-fact.html'),
  bindings: {
    /* 
      Inputs
      hero: '<',    // one-way binding, changing shoudln't update parent scope
                       mutations to objects or arrays should occur in parent
      comment: '@'  // for static strings
      Outputs: & bindings, callbacks for component events
      onDelete: '&'
      onUpdate: '&'
    */
    name: '@',
    options: '<',
    fact: '<',
    case: '<',
    onCancel: '&',
    onNext: '&',
    onUpdate: '&',
    onToggleCases: '&',
    onOpenCase: '&'
  },
  controller: fbFactCtrl
}

export default angular.module('components.fbFact', [ExtractionServ, fbTrix,
    fbEditable,
    fbDateField, fbIssueSelect, fbTagSelect, fbSourceSelect,
    IssuesTreeFactory, SourcesTreeFactory, TagsTreeFactory
  ])
  .component('fbFact', fbFact)
  .name;



// WEBPACK FOOTER //
// ./project/components/fb-fact/index.js